import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Button, Form, Upload, Select, notification, Modal, Input, Card, Icon, message } from "antd";
import { OrderedMap, List } from "immutable";
import { Table } from "components";
import { AccountSummaryRecord } from "records/account-view-record";
import { INPUT_TYPES } from "constants";
import { onCellGenerator } from "constants/table-columns";
import { readSpreadsheet } from "utilities/excel-utils";
import { formatCurrency } from "utilities";
import { CASE_CATEGORY_TYPES } from "constants/enums";
import CaseService from "services/case-service";
import AccountViewService from "services/account-view-services"; 
import "styles/form.css";
import { fieldGenerator, getErrorOnField, getValidateStatus } from "utilities/form";
import GridData from "../templates/case-details-tabs/account-grid-data";
import { STATE_STATUS } from "../constants";

const { Option } = Select;


const EXISTING_CASES_LIST_COLS = new OrderedMap({
    caseId: {
        title: "Case ID",
        dataIndex:"id",
        key: "id",
        render: _ => `PGCP-${_}`,
        width: 40,
        align: "center",
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ],
    },
    fi: {
        title: "FI",
        key: "fi",
        dataIndex: "fi",
        width: 40,
        align: "center"
    },
    progcap_score: {
        title: "Progcap Score",
        dataIndex: "progcap_score",
        key: "progcap_score",
        render: _ => formatCurrency(_, true),
        width: 60,
        align: "center"
    },
    main_borrower_cibil: {
        title: "Main Borrower CIBIL",
        dataIndex: "main_borrower_cibil",
        key: "main_borrower_cibil",
        render: _ => formatCurrency(_, true),
        width: 60,
        align: "center"
    },
    requesting_user: {
        title: "Requesting User",
        dataIndex: "requesting_user",
        key: "requesting_user",
        render: _ => formatCurrency(_, true),
        width: 80,
        align: "center"
    },
    case_type: {
        title: "Case Type",
        key: "case_type",
        dataIndex: "case_type",
        render: _ => CASE_CATEGORY_TYPES.findKey(__ => __ == _),
        width: 60,
        align: "center"
    },
    sanctioned_limit: {
        title: "Sanctioned Limit",
        dataIndex: "sanctioned_limit",
        key: "sanctioned_limit",
        render: _ => formatCurrency(_, true),
        width: 60,
        align: "center"
    },
    outstanding_limit: {
        title: "Outstanding Limit",
        dataIndex: "outstanding_limit",
        key: "outstanding_limit",
        render: _ => formatCurrency(_, true),
        width: 60,
        align: "center"
    },
    limit_utilization_perc: {
        title: "Limit Utilization (%)",
        dataIndex: "limit_utilization_perc",
        key: "limit_utilization_perc",
        width: 70,
        align: "center"
    }
});
class AdhocCaseForm extends React.Component {
    state = {
        adhoc_cases: new List([]),
        new_adhoc_list: new List([]),
        sales_manager_users: null,
        lending_partners: null,
        caseType: null,
        accountSummary: new AccountSummaryRecord({}),
        isModalVisisble: false,
        caseId: null,
        previousSanctionedCases: new List([]),
    };

    ADHOC_CASES_COLS = new OrderedMap({
        case_id: {
            title: "Case ID",
            dataIndex: "case_id",
            key: "case_id",
            // editable: true,
            onCellGenerator
        },
        existing_limit: {
            title: "Existing Limit",
            dataIndex: "existing_limit",
            key: "existing_limit",
            editable: false,
            viewable: true,
            align: "center"
        },
        // overdue_amount: {
        //     title: "Overdue Amount",
        //     dataIndex: "overdue_amount",
        //     key: "overdue_amount",
        //     editable: false,
        //     viewable: true,
        //     align: "center"
        // },
        proposed_limit: {
            title: "Proposed Limit",
            dataIndex: "proposed_limit",
            key: "proposed_limit",
            editable: true,
            onCellGenerator
        },
        // sales_manager_user_email: {
        //     title: "Primary Sales Manager",
        //     dataIndex: "sales_manager_user_email",
        //     key: "sales_manager_user_email",
        //     editable: true,
        //     fieldType: INPUT_TYPES.SELECT,
        //     options: this.props.sales_manager_users ? this.props.sales_manager_users.map(_ => ({
        //         label: _.email,
        //         value: _.email
        //     })) : [],
        //     onCellGenerator
        // },
        bank_code: {
            title: "Lending Partner",
            dataIndex: "bank_code",
            key: "bank_code",
            fieldType: INPUT_TYPES.SELECT,
            editable: true,
            options: this.props.lending_partners ? this.props.lending_partners.map(_ => ({
                label: _.code,
                value: _.code
            })) : [],
            onCellGenerator
        },
        sales_manager_user_id: {
            title: "Area Sales Manager",
            dataIndex: "sales_manager_user",
            key: "sales_manager_user",
            fieldType: INPUT_TYPES.SELECT,
            editable: true,
            options: this.props.sales_manager_users && this.props.sales_manager_users.length ? new List(this.props.sales_manager_users.map((_) => ({
                label: _.full_name,
                value: _.full_name
            }))).toList().toArray() : [],
            // rules: [
            //     {
            //         required: true,
            //         message: "Field Required"
            //     }
            // ],
            onCellGenerator
        },
        inside_sales_personnel: {
            title: "Inside Sales Personnel",
            dataIndex: "inside_sales_personnel",
            key: "inside_sales_personnel",
            fieldType: INPUT_TYPES.SELECT,
            editable: true,
            // notFoundContent: "This Sales person doesn't exist, you need to create it.",
            // onSearch: () => CompanyService.getISPList(),
            options: this.props.insideSalesPersonolleData ? this.props.insideSalesPersonolleData.map(el=>({
                label:el.full_name,
                value:el.id,
            })) : null,
            onCellGenerator
        },
        remove: {
            title: "",
            dataIndex: "remove",
            key: "remove",
            render: (_, record) => {
                return <div className={"d-flex align-items-center justify-content-center"}>
                    <Icon onClick={() => this.onRemove(record)} type={"close-circle"} style={{fontSize: 16, color: "red"}} />
                </div>;
            }
        }
    });

    onRemove = row => {
        let existingData = this.state.new_adhoc_list;
        existingData = existingData.filter(_ => _.key != row.key);
        this.setState({
            new_adhoc_list: existingData
        });
    }

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);

    componentDidUpdate(prevProps) {
        if(prevProps.status === STATE_STATUS.CREATING && this.props.status === STATE_STATUS.CREATED){
            this.setState({
                new_adhoc_list: new List([])
            });
        }
    }

    saveCases = () => {
        let data = this.state.new_adhoc_list && this.state.new_adhoc_list.size ? 
            this.state.new_adhoc_list.toArray() : [];
        data = data.map(({case_id, bank_code, proposed_limit, sales_manager_user, inside_sales_personnel}) => {
            let asm = this.props.sales_manager_users && this.props.sales_manager_users.length ? this.props.sales_manager_users.filter((item) => item.full_name == sales_manager_user):null;
            sales_manager_user = asm?asm[0]?.id:sales_manager_user;
            return {
                case_id,
                bank_code,
                proposed_limit,
                create: true,
                case_type: this.state.caseType,
                sales_manager_user ,
                inside_sales_personnel,
            };
        });
        !this.state.caseType ? message.error("Please select the case type") : data && (!(data.find(el=>el.sales_manager_user == undefined)) || !(data.find(el=>el.inside_sales_personnel === undefined)))  ? this.props.createBulkAdhocCase(data) : message.error("Please fill either Area Sales Manager Field or Inside Sales Personnel");
    };

    getExistingLimit = async (case_id, isCaseIdEdited) => await CaseService.getExistingCaseLimit(case_id).then(({ data }) => {
        if(data) {
            if(data.adhoc_case_list && data.adhoc_case_list.length && isCaseIdEdited) {
                let cases = data.adhoc_case_list.map(_ => `PGCP-${_}`).join(", ");
                notification.warning({
                    message: "Previous Adhoc Cases",
                    description: `${cases} are adhoc cases that have already been created from this case`
                });
            }
            return {
                existing_limit: formatCurrency(data.existing_limit),
                overdue_amount: formatCurrency(data.overdue_amount),
                bank_code: data.bank_code === "" ?  null : data.bank_code,
            };
        }
        return {};
    });

    readFile = async (file) => {
        let data = await readSpreadsheet(file);
        data = data.filter(_ => _.case_id).map(async _ => {
            if(_.case_id) {
                let existing_limit = await this.getExistingLimit(_.case_id);
                return {
                    ..._,
                    ...existing_limit,
                    bank_code: _.bank_code
                };
            }
            return _;
        });
        Promise.all(data).then((values) => {
            data = new List([...values, ...this.state.new_adhoc_list]);
            this.setState({
                new_adhoc_list: data,
            });
        });
    };

    handleSaveMultipleEntries = async(record, values, dataIndex) => {
        let data = new List([]);
        let existingObjIndex = this.state.new_adhoc_list.findIndex(_ => _.id === record.id);
        if(existingObjIndex >=0) {
            data = this.state.new_adhoc_list.setIn([existingObjIndex], {
                ...record,
                ...values
            });
        
        } else {
            const existing_limit = await this.getExistingLimit(values.case_id, dataIndex === "case_id");
            data = data.push({
                ...record,
                ...values,
                ...existing_limit,
                id: record.id
            });
        }
        this.setState({
            new_adhoc_list: new List(data)
        });
    }

    onSelectCaseType = (val) => {
        this.setState({
            caseType: val
        });
    }

    addNewRow = async () => {
        let sizeOfList = this.state.new_adhoc_list.size;
        this.setState({
            new_adhoc_list: this.state.new_adhoc_list.push({ id: (sizeOfList + 1) })
        });
    }

    downloadSampleSheet = () => {
        return import(/* webpackChunkName: "xlsx" */ "xlsx")
            .then(_ => _.default)
            .then(async XLSX => {
                let cols = this.ADHOC_CASES_COLS.map(_ => _.dataIndex).filter(_ => _ !== "existing_limit").toList();
                let ws = await XLSX.utils.json_to_sheet([], {header: cols.toArray()});
                let wb = await XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
                const wbout = XLSX.writeFile(wb, "sample-adhoc_cases.xlsx");
                return wbout;
            });
    }

    toggleCaseModal = () => {
        this.setState({
            isModalVisisble: !this.state.isModalVisisble
        });
    }

    onCaseIdEnter = event => {
        this.setState({
            caseId: event.target.value
        });
    }

    onCaseInputBlur = async () => {
        if(this.state.caseId){
            AccountViewService.getAccountSummary(this.state.caseId).then(({data}) => {
                this.setState({
                    accountSummary: new AccountSummaryRecord(data)
                });
            });
            CaseService.getPreviousSanctionedList(this.state.caseId).then(({ data: { results } }) => {
                this.setState({
                    previousSanctionedCases: new List(results)
                });
            });
        }
    }

    addRowToTable = async () => {
        let sizeOfList = this.state.new_adhoc_list.size;
        const data = await this.getExistingLimit(this.state.caseId);
        this.setState({
            new_adhoc_list: this.state.new_adhoc_list.push({ 
                id: (sizeOfList + 1),
                case_id: this.state.caseId,
                key: Date.now().toString(36),
                proposed_limit: null,
                ...data
            })
        });
    }

    addCaseDetailToTable = async () => {
        await this.addRowToTable();
        this.onCloseModal();
    }

    onCloseModal = () => {
        this.setState({
            isModalVisisble: false,
            previousSanctionedCases: new List([]),
            caseId: null,
            accountSummary: new AccountSummaryRecord({})
        });
    }

    renderCaseViewModal = () => {
        return (
            <Modal
                visible={this.state.isModalVisisble}
                closable={true}
                destroyOnClose={true}
                width={1000}
                footer={null}
                onCancel={this.onCloseModal}
            >
                <Row>
                    <Col span={14} className={"mt-10"}>
                        <span>Enter Case ID</span>
                        <Row span={21}>
                            <Col span={8}>
                                <Input
                                    placeholder={"1234"}
                                    value={this.state.caseId}
                                    onChange={this.onCaseIdEnter}
                                    onPressEnter={this.onCaseInputBlur}
                                />
                            </Col>
                            {this.state.previousSanctionedCases.size ? 
                                <Col offset={1} span={12}>
                                    <span>{this.state.previousSanctionedCases.getIn([0, "company"])}</span>
                                </Col>
                                : null}
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Card
                        style={{
                            boxShadow: "none"
                        }}
                        title={"Existing Case(s)"}
                        className={"padless-card no-shadow-card mt-10"}
                    >
                        <Table
                            showTopSection={false}
                            pagination={false}
                            noRowSelection={true}
                            size={"small"}
                            columns={EXISTING_CASES_LIST_COLS}
                            data={this.state.previousSanctionedCases}
                        />
                    </Card>
                </Row>
                <Row>
                    <Col className={"mt-10"}>
                        <GridData
                            data={this.state.accountSummary}
                            // status={"FETCHED"}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button disabled={!this.state.caseId} onClick={this.addCaseDetailToTable} type={"primary"} size={"default"}>Add Case</Button>
                    </Col>
                </Row>
            </Modal>
        );
    }

    render() {
        return (
            <Row>
                <Col span={24} className={"d-flex justify-content-space-between"}>
                    <Select
                        style={{
                            width: "250px"
                        }}
                        placeholder={"Select Case Type"}
                        onSelect={this.onSelectCaseType}
                    >
                        {CASE_CATEGORY_TYPES.map((_, k) => (
                            <Option key={k} value={_}>
                                {k}
                            </Option>
                        )).toList().toArray()}
                    </Select>
                    <div>
                        <Button type={"primary"} icon={"download"} onClick={this.downloadSampleSheet} className={"mr-10"}>
                            {"Download Sample Sheet"}
                        </Button>
                        <Upload
                            beforeUpload={(file) => this.readFile(file)}
                            action={null}
                        >
                            <Button type={"primary"} icon={"upload"}>
                                {"Upload Data Sheet"}
                            </Button>
                        </Upload>
                    </div>
                </Col>
                <Col span={24} className={"mt-10"}>
                    {this.state.new_adhoc_list.size ? <Table
                        columns={this.ADHOC_CASES_COLS.map(({ onCellGenerator, editable, ...restColFields}) => {
                            if (!onCellGenerator || !editable) {
                                return { ...restColFields };
                            }
                            return {
                                onCell: onCellGenerator(
                                    this.handleSaveMultipleEntries,
                                    // this.handleSaveMultipleEntries.bind(null, restColFields.dataIndex),
                                    restColFields,
                                ),
                                ...restColFields
                            };
                        })}
                        type={"inner"}
                        showTopSection={false}
                        noRowSelection={true}
                        data={this.state.new_adhoc_list}
                        editable={true}
                    /> : null}
                </Col>
                {!this.state.new_adhoc_list.size ? <Col span={24} className={"mt-10 d-flex justify-content-center"}>
                    <Button onClick={this.toggleCaseModal} type={"primary"} size={"default"}>Add Case</Button>
                </Col> : null}
                {this.state.new_adhoc_list.size ? <Col span={24} className={"mt-10 d-flex justify-content-space-between"}>
                    <Button type={"dashed"} size={"small"} onClick={this.toggleCaseModal}>Add Case</Button>
                    <Button type={"primary"} size={"small"} onClick={this.saveCases}>Submit</Button>
                </Col> : null}
                {this.state.isModalVisisble ? this.renderCaseViewModal() : null}
            </Row>
        );
    }

}

AdhocCaseForm.propTypes = {
    form: PropTypes.object,
    lending_partners: PropTypes.array,
    insideSalesPersonolleData: PropTypes.array,
    sales_manager_users: PropTypes.array,
    createBulkAdhocCase: PropTypes.func,
    status: PropTypes.string
};

export default Form.create({})(AdhocCaseForm);
